// extracted by mini-css-extract-plugin
export default {"location__city":"Location_location__city__289RE"};